import React, { Component } from 'react';
import OriginTimePicker from 'bee-timepicker';
import moment from 'moment';
import { DongbaToLocalTime, LocalToDongbaTime, isDongba, locale, localeLang } from '@platform/api';
// import 'moment/locale/zh-cn';
// import 'moment/locale/zh-tw';
// import 'moment/locale/en-au';
require('bee-timepicker/build/Timepicker.css');
import { getSysFieldid } from '@platform/api';

// if (localeLang === 'simpchn') {
// 	moment.locale('zh-cn');
// } else if (localeLang === 'english') {
// 	moment.locale('en');
// } else if (localeLang === 'tradchn') {
// 	moment.locale('zh-tw');
// } else {
// 	moment.locale(`${localeLang}`);
// }
let localeZoneIsDongba = isDongba();

require('./index.less');

export default class TimepickerClient extends Component {
	constructor(props) {
		super(props);
		this.state = {
			current: null,
			open: this.props.datepickerOpen || false,
		};
	}

	componentWillMount() {
		window.addEventListener('click', this.close, false);

		this.getDefaultTime(this.props, () => { });
	}

	componentWillUnmount() {
		// 移除document事件
		window.removeEventListener('click', this.close);
	}

	componentWillReceiveProps(nextProps) {
		this.getDefaultTime(nextProps, () => { });
		this.setState({
			open: nextProps.datepickerOpen,
		});
	}

	onClick = e => {
		// let a = ReactDOM.findDOMNode(this.i);
		this.props.onClick && this.props.onClick(e);
		this.setState({
			open: this.props.datepickerOpen == undefined ? true : this.state.open,
		});
	};

	onChange = v => {
		let BeijinVal = null;
		let { operationSign, notconverttimezones } = this.props;
		let now = null;
		// 东八区的时间 转为本地时间
		if (v) {
			BeijinVal = !localeZoneIsDongba
				? LocalToDongbaTime(moment(`${moment.format('YYYY-MM-DD')} ${v.format('HH:mm:ss')}`), notconverttimezones)
				: moment(`${moment.format('YYYY-MM-DD')} ${v.format('HH:mm:ss')}`);
		}
		this.props.onChange &&
			this.props.onChange(
				BeijinVal ? BeijinVal.format('YYYY-MM-DD HH:mm:ss') : null,
				v ? v.format('HH:mm:ss') : now,
			);
	};

	close = e => {
		const { onBlur, value } = this.props;
		if (this.select && !this.select.contains(e.target)) {
			typeof onBlur === 'function' && onBlur(value);
		}
	};

	// 用来判断和处理时间函数
	timeMomentHandler = (val, list = []) => {
		let result = false;
	    /*if (isArray(val)) {
            val.forEach(item => {
                if (typeof item === 'string' && item.indexOf('#') !== -1) {
                    result = true;
                }
                result && list.push(item);
            })

        }*/
		result = Object.prototype.toString.call(val) === '[object Object]';
		return result;
	};

	// 初始化默认值
	getDefaultTime = (props, callback) => {
		// callback()
		let BeijinVal = props.value;
		let currentVal = null;
		if (BeijinVal) {
			if (this.timeMomentHandler(BeijinVal)) {
				currentVal = moment(
					!localeZoneIsDongba
						? DongbaToLocalTime(BeijinVal, props.notconverttimezones).format('HH:mm:ss')
						: BeijinVal.format('HH:mm:ss'),
					'HH:mm:ss',
				);
			} else {
				currentVal = moment(
					!localeZoneIsDongba
						? DongbaToLocalTime(moment(BeijinVal), props.notconverttimezones).format('HH:mm:ss')
						: moment(BeijinVal).format('HH:mm:ss'),
					'HH:mm:ss',
				);
			}
		}
		this.setState({
			current: currentVal || null,
			localeLang,
		});
	};

	render() {
		let required = this.props && this.props.showStar;
		let { format = 'HH:mm:ss', value, onChange, fieldid, popupClassName, ...others } = this.props;
		let finalFormat = getDatetimeFormat(format);
		let { current } = this.state;
		fieldid = getSysFieldid(fieldid);
		if (!popupClassName && fieldid) {
			popupClassName = `fieldid_${fieldid}_calendar`;
		}

		moment.locale('en');

		// let {showStar, open, tableOpen} = this.props;
		return (
			<div
				className={`u-form-control-wrapper ${this.props.className}`}
				fieldid={fieldid || null}
				ref={dom => {
					this.select = dom;
				}}
				onClick={e => {
					e.stopPropagation();
				}}
			>
				{required ? <span className="time-picker-required-tag">*</span> : ''}
				<OriginTimePicker
					popupClassName={popupClassName + ' nc-time-picker-panel'}
					value={current || null}
					format={finalFormat}
					onChange={this.onChange}
					//locale={locale}
					{...others}
					onOpen={this.onClick}
					open={this.state.open}
					onClose={() => {
						typeof this.props.onOpenChange === 'function' && this.props.onOpenChange(false);
						typeof this.props.onClose === 'function' && this.props.onClose();
						this.setState({
							open: this.props.datepickerOpen == undefined ? false : this.state.open,
						});
					}}
				/>
			</div>
		);
	}
}
